import { Epic, StateObservable, ofType } from 'redux-observable';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Observable, catchError, concatMap, from, mergeMap, of } from 'rxjs';
import { ToastNotification } from '@scenario/models/toast-notification.model';
import { displayToast } from '@store/toast-notifications/toast-notifications-slice';
import {
  retrievePriceCardSubscriptions,
  subscribeToPriceCardFailure,
  subscribeToPriceCardSuccess,
} from '@store/price-card/subscription/subscription.slice';
import { Subscription } from '@price-card/models/subscription.model';


export const subscribeToPriceCardEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('price-card-subscriptions/subscribeToPriceCard'),
    concatMap((action: PayloadAction<Subscription>) =>
      from(dependencies.priceCardSubscriptionGateway
          .subscribeByPriceZoneAndTechnologyAndCommercialOperationDate(action.payload)).pipe(
        mergeMap((subscription) => {
          const toastNotification: ToastNotification = {
            title: 'Price Card Subscription',
            content: 'Successfully subscribed to this price zone, technology and commercial operation',
            status: 'info',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          return of(subscribeToPriceCardSuccess(subscription), retrievePriceCardSubscriptions(), displayToast(toastNotification));
        }),
        catchError(() => {
          const toastNotification: ToastNotification = {
            title: 'Price Card Subscription',
            content: 'Already subscribed to this price zone, technology and commercial operation',
            status: 'danger',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          return of(subscribeToPriceCardFailure('Fail to subscribed'), displayToast(toastNotification));
        }),
      ),
    ),
  );
